import React from 'react';

import NavHorizontal from "../NavHorizontal";
import { Popover } from 'antd';
import './style.scss';

interface itemInterface {
  id: number;
  name?: string;
  title?: string;
  url: string;
}

interface itemsInterface {
  [key: string]: itemInterface | undefined
}

interface propsInterface {
  children: React.ReactNode;
  items: itemsInterface | undefined;
  itemIds: number[] | string[] | undefined;
  parent?: itemInterface;
  activeId: number | undefined;
  placement?: any;
  popoverProps?: object;
}

const NavDropdown = ({ children, items, itemIds, parent, activeId, popoverProps }: propsInterface) => {
  const defaultPopoverProps: object = {
    placement: 'bottom',
    trigger: 'click'
  };

  const mergedPopoverProps = {
    overlayClassName: '',
    ...defaultPopoverProps, ...popoverProps
  };

  mergedPopoverProps.overlayClassName += ' v-dropdown';

  function Menu() {
    if (!itemIds || !items) {
      return null;
    }

    return <NavHorizontal items={items} itemIds={itemIds} activeId={activeId} parent={parent} />
  }

  return (
    <Popover {...mergedPopoverProps} content={Menu}>
      {children}
    </Popover>
  );
}

export default NavDropdown;